<template>
  <el-dialog
      :visible.sync="visible"
      :title="title"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      width="80%"
      top="5vh"
      v-loading="loading"
  >
    <div class="dialog-content" style="padding-right:20px;">
      <el-form
          :model="dataForm"
          :rules="dataRule"
          ref="dataForm"
          label-width="120px"
      >
        <el-row :gutter="16">
          <el-col :span="8">
            <el-form-item label="订单编号：" prop="agreementCode">
              <OrderDrop v-model="dataForm.agreementCode"
                         placeholder="请输入订单编号"></OrderDrop>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item :label="optName + '时间：'" prop="operateTime">
              <el-date-picker
                  v-model="dataForm.operateTime"
                  type="date"
                  value-format="yyyy-MM-dd"
                  style="width: 100%"
                  :placeholder="`选择出${optName}时间`"
              >
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item :label="optName + '仓库：'" prop="storageId">
              <storages v-model="dataForm.storageId"/>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="物流公司：" prop="carriageMan">
              <dict v-model="dataForm.carriageMan" dictName="carriage_man"/>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="物流号：" prop="carriageNo">
              <el-input v-model="dataForm.carriageNo"/>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="备注：" prop="remark">
              <el-input
                  v-model="dataForm.remark"
                  placeholder="备注"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-form-item label="凭证照片：" prop="imgs">
          <MultipleImageUpload v-model="dataForm.imgs"></MultipleImageUpload>
        </el-form-item>

        <el-card style="margin-top:20px;">
          <div slot="header" class="card-header">
            <div>本次{{ optName }}明细</div>
            <el-button
                v-if="canEditDetail"
                size="mini"
                icon="el-icon-plus"
                @click="addRow()"
                type="primary"
            >增加明细
            </el-button
            >
          </div>
          <el-table :data="dataForm.detailList" :max-height="335" border style="width: 100%">
            <el-table-column
                type="index"
                width="50"
                label="行号"
                header-align="center"
                align="center"
            ></el-table-column>
            <el-table-column
                label="品番号"
                prop="code"
                align="center"
                v-if="productType === '产品'"
            >
              <template slot-scope="scope">
                <el-form-item
                    :prop="'detailList.' + scope.$index + '.code'"
                    :rules="detailRule.code"
                    label-width="0"
                    style="margin-top: 20px"
                    v-if="canEditDetail&&!scope.row.productId"
                >
                  <el-input
                      size="mini"
                      v-model="scope.row.code"
                      placeholder="请输入品番号"
                  ></el-input>
                </el-form-item>
                <span v-else>{{scope.row.code}}</span>
              </template>
            </el-table-column>
            <el-table-column label="品名" prop="name" align="center">
              <template slot-scope="scope">
                <el-form-item
                    :prop="'detailList.' + scope.$index + '.name'"
                    :rules="detailRule.name"
                    label-width="0"
                    style="margin-top: 20px"
                    v-if="canEditDetail&&!scope.row.productId"
                >
                  <el-input
                      size="mini"
                      v-model="scope.row.name"
                      placeholder="请输入品名"
                  ></el-input>
                </el-form-item>
                <span v-else>{{scope.row.name}}</span>
              </template>
            </el-table-column>
            <el-table-column label="颜色" prop="color" align="center">
              <template slot-scope="scope">
                <el-form-item
                    :prop="'detailList.' + scope.$index + '.color'"
                    label-width="0"
                    style="margin-top: 20px"
                    v-if="canEditDetail&&!scope.row.productId"
                >
                  <el-input
                      size="mini"
                      v-model="scope.row.color"
                      placeholder="请输入颜色"
                  ></el-input>
                </el-form-item>
                <span v-else>{{scope.row.color}}</span>
              </template>
            </el-table-column>
            <el-table-column label="规格" prop="size" align="center">
              <template slot-scope="scope">
                <el-form-item
                    :prop="'detailList.' + scope.$index + '.size'"
                    label-width="0"
                    style="margin-top: 20px"
                    v-if="canEditDetail&&!scope.row.productId"
                >
                  <el-input
                      size="mini"
                      v-model="scope.row.size"
                      placeholder="请输入规格"
                  ></el-input>
                </el-form-item>
                <span v-else>{{scope.row.size}}</span>
              </template>
            </el-table-column>
            <el-table-column
                label="幅宽"
                prop="attr1"
                align="center"
                v-if="productType === '原料'"
            >
              <template slot-scope="scope">
                <el-form-item
                    :prop="'detailList.' + scope.$index + '.attr1'"
                    label-width="0"
                    style="margin-top: 20px"
                    v-if="canEditDetail&&!scope.row.productId"
                >
                  <el-input
                      v-model="scope.row.attr1"
                      placeholder="请输入幅宽"
                  ></el-input>
                </el-form-item>
                <span v-else>{{scope.row.attr1}}</span>
              </template>
            </el-table-column>
            <el-table-column
                label="克重"
                prop="attr2"
                align="center"
                v-if="productType === '原料'"
            >
              <template slot-scope="scope">
                <el-form-item
                    :prop="'detailList.' + scope.$index + '.attr2'"
                    label-width="0"
                    style="margin-top: 20px"
                    v-if="canEditDetail&&!scope.row.productId"
                >
                  <el-input
                      v-model="scope.row.attr2"
                      placeholder="请输入克重"
                  ></el-input>
                </el-form-item>
                <span v-else>{{scope.row.attr2}}</span>
              </template>
            </el-table-column>
            <el-table-column
                label="当前库存"
                prop="oldCount"
                header-align="center"
                align="center"
                width="120"
            ></el-table-column>
            <el-table-column
                label="本次数量"
                header-align="center"
                align="center"
                width="160"
            >
              <template slot-scope="scope">
                <el-form-item
                    :prop="'detailList.' + scope.$index + '.count'"
                    :rules="detailRule.count"
                    label-width="0"
                    style="margin-top: 20px"
                >
                  <el-input v-model="scope.row.count" size="mini"></el-input>
                </el-form-item>
              </template>
            </el-table-column>
            <el-table-column
                label="B品数量"
                header-align="center"
                align="center"
                width="160"
                v-if="hasCountB"
            >
              <template slot-scope="scope">
                <el-form-item
                    :prop="'detailList.' + scope.$index + '.countB'"
                    :rules="detailRule.countB"
                    label-width="0"
                    style="margin-top: 20px"
                >
                  <el-input v-model="scope.row.countB" size="mini"></el-input>
                </el-form-item>
              </template>
            </el-table-column>

            <el-table-column
                header-align="center"
                align="center"
                width="100"
                label="操作"
                fixed="right"
            >
              <template slot-scope="scope">
                <el-button
                    icon="el-icon-remove"
                    type="text"
                    @click="delRow(scope.$index, scope.row, 'detailList')"
                >
                  移除
                </el-button>
              </template>
            </el-table-column>
          </el-table>
        </el-card>
      </el-form>
    </div>
    <template slot="footer">
      <el-button @click="cancel()">{{ $t("cancel") }}</el-button>
      <el-button type="primary" @click="dataFormSubmitHandle()">{{
          $t("confirm")
        }}
      </el-button>
    </template>
  </el-dialog>
</template>

<script>
import OrderDrop from '@/components/order-drop'
import debounce from "lodash/debounce";
import MultipleImageUpload from "@/components/MultipleImageUpload";
import SaveRule from "./form-rule";
import moment from "moment";

export default {
  mixins: [SaveRule],
  components: {MultipleImageUpload, OrderDrop},
  data() {
    return {
      id: "",
      dataForm: {},
      visible: false,
      loading: false,
      hasCountB: window.SITE_CONFIG["hasCountB"],
      productType: "",
      title: "",
      storeType: "",
      storeTypeName: {
        "1": "入库",
        "-1": "出库",
      },
    };
  },
  watch: {
    "dataForm.storageId": {
      handler: function (newVal) {
        if (!newVal) {
          return
        }
        if (this.productType === "产品"&&this.storeType == 1) {
          return
        }
        this.getAgreementStore(this.dataForm.agreementCode)
      },
      immediate: true,
    },
    "dataForm.agreementCode": {
      handler: function (newVal) {
        if (newVal) {
          if (this.productType === "产品"&&this.storeType == 1) {
            this.getAgreement(newVal);
          }else{
            this.getAgreementStore(newVal)
          }
        }
      },
      immediate: true,
    },
  },
  computed: {
    canEditDetail() {
      if (this.productType === "产品") {
        return false
      } else {
        if (this.storeType == -1) {
          return false
        }
      }
      return true
    },
    optName() {
      return this.storeTypeName[String(this.storeType)];
    },
  },
  methods: {
    //根据合同编号获取库存情况
    getAgreementStore(code) {
      this.$http.get(`/trade/factorystore/page`, {
        params: {
          page: 1,
          limit: 10000,
          productType: this.productType,
          agreementCode: code,
          storageId:this.dataForm.storageId
        }
      }).then(({data: res}) => {
        this.dataForm.detailList = res.data.list.map((item) => {
          return {
            code: item.code,
            name: item.name,
            productId: item.productId,
            oldCount: item.count,
            color: item.color,
            size: item.size,
            attr1:item.attr1,
            attr2:item.attr2,
            count: 0,
            countB: 0
          };
        });
      })
    },
    async getAgreement(code) {
      const {data: res} = await this.$http.get(
          `/trade/agreement/code/${code}`
      );
      if (res.code !== 0) {
        return this.$message.error(res.msg);
      }
      if (res.data && res.data.detailList && res.data.detailList.length > 0) {
        this.dataForm.detailList = res.data.detailList.map((item) => {
          return {
            code: item.code,
            name: item.name,
            productId: item.productId,
            color: item.color,
            size: item.size,
            count: 0,
            countB: 0,
            oldCount:item.storeCount
          };
        });
      }
    },
    cancel() {
      this.visible = false;
    },
    addRow() {
      this.dataForm.detailList.push(this.getNewDetailRow());
    },
    delRow(index, row, dataKey) {
      if (this.dataForm[dataKey]) {
        this.dataForm[dataKey].splice(index, 1);
      }
    },
    getNewDetailRow() {
      return {
        id: "",
        code: "",
        name: "",
        color: "",
        size: "",
        attr1: "",
        attr2: "",
        count: "",
        countB: '',
        oldCount:0
      };
    },
    async reset() {
      this.imgArr = [];
      this.dataForm = {
        id: "",
        remark: "",
        operateTime: moment().format("yyyy-MM-DD"),
        storageId: "",
        carriageNo: "",
        carriageMan: "",
        imgs: "",
        agreementCode: "",
        detailList: [],
      };
      if(this.canEditDetail){
        this.dataForm.detailList.push(this.getNewDetailRow())
      }
      if (this.$refs["dataForm"]) {
        this.$refs["dataForm"].resetFields();
      }
    },
    init() {
      this.visible = true;
      this.$nextTick(() => {
        this.reset();
      });
    },
    // 表单提交
    dataFormSubmitHandle: debounce(
        function () {
          this.$refs["dataForm"].validate((valid) => {
            if (!valid) {
              return false;
            }
            if (
                !this.dataForm.detailList ||
                this.dataForm.detailList.length === 0
            ) {
              return this.$message.error("明细不能为空");
            }
            let postForm = [];
            this.dataForm.detailList.forEach((item) => {
              if (!item.countB && !item.count) {
                return;
              }
              if (item.count <= 0 && item.countB <= 0) {
                return;
              }
              postForm.push({
                countB: item.countB,
                count: item.count,
                agreementCode: this.dataForm.agreementCode,
                productName: item.name,
                productCode: item.code,
                size: item.size,
                color: item.color,
                attr1: item.attr1,
                attr2: item.attr2,
                type: this.storeType,
                operateTime: this.dataForm.operateTime,
                productType: this.productType,
                storageId: this.dataForm.storageId,
                imgs: this.dataForm.imgs
              });
            });
            this.loading = true;
            this.$http
                .post("/trade/factorystorelog", postForm)
                .then(({data: res}) => {
                  this.loading = false;
                  if (res.code !== 0) {
                    return this.$message.error(res.msg);
                  }
                  this.$message({
                    message: this.$t("prompt.success"),
                    type: "success",
                    duration: 500,
                    onClose: () => {
                      this.cancel();
                      this.$emit("refreshDataList");
                    },
                  });
                })
                .catch((e) => {
                  console.log(e);
                  this.loading = false;
                });
          });
        },
        1000,
        {leading: true, trailing: false}
    ),
  },
};
</script>

<style lang="scss" scoped>
.dialog-content {
  max-height: 70vh;
  overflow-y: auto;
}
</style>
